import dagre from '@dagrejs/dagre'

const DEFAULT_NODE_WIDTH = 220
const DEFAULT_NODE_HEIGHT = 80

/**
 * Computes a top-down hierarchical layout for xyflow nodes using dagre.
 * Returns a new array of nodes with updated position values.
 */
export function autoLayout (nodes, edges, { nodeWidth = DEFAULT_NODE_WIDTH, nodeHeight = DEFAULT_NODE_HEIGHT } = {}) {
  const g = new dagre.graphlib.Graph()
  g.setGraph({ rankdir: 'TB', nodesep: 60, ranksep: 100 })
  g.setDefaultEdgeLabel(() => ({}))

  nodes.forEach(n => g.setNode(n.id, { width: nodeWidth, height: nodeHeight }))
  edges.forEach(e => g.setEdge(e.source, e.target))

  dagre.layout(g)

  return nodes.map(n => {
    const { x, y } = g.node(n.id)
    return {
      ...n,
      position: { x: x - nodeWidth / 2, y: y - nodeHeight / 2 }
    }
  })
}
